import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { GetCountries } from "../../../api/masters/countryAPI";
import { BulkImportState, StoreState } from "../../../api/masters/stateAPI";
import BulkImport from "../../../components/BulkImport";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  countryId: yup.string().required("Country is required")
});

const AddState = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [states, setStates] = useState([]);

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchCountry = async () => {
    try {
      const response = await GetCountries(); // Make sure login function returns token
      if (response.success) {
        setStates(response.data);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(() => {
    const loadData = async () => {
      try {
        dispatch({ type: "LOADER_START" });

        await fetchCountry();
      } catch (error) {
        showToast("error", error);
      } finally {
        dispatch({ type: "LOADER_STOP" });
      }
    };

    loadData();
  }, []);

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await StoreState(data);
      if (response.success) {
        showToast("success", response.message);
        navigate(`/masters/state/list`);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  const bulkColumns = [
    { key: "name", label: "State Name", sample: "Andhra Pradesh" },
    { key: "country", label: "Country", sample: "India" }
  ];

  const handleBulkImport = async payload => {
    const response = await BulkImportState(payload);

    if (response.success) {
      showToast("success", response.message);
      navigate("/masters/state/list");
    } else {
      showToast("error", response.message);
    }
  };

  return (
    <Fragment>
      <Breadcrumb parent="State" title="Add State" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Add State</h5>
                  <Link to={`/masters/state/list`}>
                    <button className="btn btn-primary" id="list">
                      List State
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List State
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Select Country*</label>
                        <select
                          className="form-select"
                          id="name"
                          type="text"
                          {...register("countryId")}
                        >
                          <option value="">Select Country</option>
                          {states.map(state =>
                            <option value={state._id}>
                              {state.name}
                            </option>
                          )}
                        </select>
                        {errors.countryId &&
                          <p className="text-danger">
                            {errors.countryId.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">State Name*</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="State Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
            <BulkImport
              columns={bulkColumns}
              onSubmit={handleBulkImport}
              payloadKey="states"
              sampleFileName="state_sample.csv"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddState;
